import { render, staticRenderFns } from "./OrderTemplateData.vue?vue&type=template&id=177d8c01&scoped=true&"
import script from "./OrderTemplateData.vue?vue&type=script&lang=js&"
export * from "./OrderTemplateData.vue?vue&type=script&lang=js&"
import style0 from "./OrderTemplateData.vue?vue&type=style&index=0&id=177d8c01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177d8c01",
  null
  
)

/* custom blocks */
import block0 from "./OrderTemplateData.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports